import React, { Component } from 'react'
import { Icon, Popup, Menu } from 'semantic-ui-react'

// Local (client-side) download formats for a generated license row.
//
// A .lic file is "<license holder id>\n<signed license block>" -- this mirrors
// exactly what the backend attaches to the license email (see
// keldaservices/utils/email_helper.py: f"{license_holder}\n{license_key}").
// The holder id (first line) is the row's license_name; the signed license
// block (BEGIN/END ... hex) is fetched per row via getLicenseKey.
//
// Add entries here to offer more local formats in the dropdown.
const FORMATS = [
    {
        key: 'kapi',
        label: 'libKeldaStraume_kapi.lic',
        filename: 'libKeldaStraume_kapi.lic',
        build: ({ licenseHolder, licenseKey }) => `${licenseHolder}\n${licenseKey}`
    }
]

export default class GeneratedLicenseDownload extends Component {
    constructor(props) {
        super(props)
        this.state = { open: false }
    }

    // Trigger a browser "save as" for the given text content.
    saveFile = (filename, content) => {
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
    }

    onSelect = async (format) => {
        this.setState({ open: false })
        // The signed license blob (+ machine id) is fetched on demand for this
        // row; the holder id (first line) comes straight from the row.
        const action = await this.props.getLicenseKey(this.props.rowId)
        const payload = (action && action.payload) || {}
        const content = format.build({
            licenseHolder: this.props.licenseHolder || '',
            licenseKey: payload.licenseKey || '',
            machineId: payload.machineId || ''
        })
        this.saveFile(format.filename, content)
    }

    render() {
        return (
            // Popup renders in a portal, so the menu is not clipped by the
            // react-table cell/body overflow.
            <Popup on='click' position='bottom right'
                   open={this.state.open}
                   onOpen={() => this.setState({ open: true })}
                   onClose={() => this.setState({ open: false })}
                   trigger={<Icon name='download' size='large' link title='Download license'/>}>
                <Menu vertical secondary>
                    <Menu.Item header>Download format</Menu.Item>
                    {FORMATS.map(f =>
                        <Menu.Item key={f.key} onClick={() => this.onSelect(f)}>
                            <Icon name='file code outline'/> {f.label}
                        </Menu.Item>
                    )}
                </Menu>
            </Popup>
        )
    }
}
